// src/BaseIcon.tsx
import { forwardRef } from "react";
import { Fragment, jsx } from "react/jsx-runtime";
var BaseIcon = forwardRef(({ size = 24, children, fallback, ...props }, ref) => {
  if (!children && fallback) {
    if (typeof fallback === "string") {
      return /* @__PURE__ */ jsx(
        "img",
        {
          ref,
          src: fallback,
          width: size,
          height: size
        }
      );
    }
    return /* @__PURE__ */ jsx(Fragment, { children: fallback });
  }
  return /* @__PURE__ */ jsx(
    "svg",
    {
      ref,
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      ...props,
      children
    }
  );
});
BaseIcon.displayName = "BaseIcon";

export {
  BaseIcon
};
